import React from 'react';

export const NotificationBanner = ({ notification, onClose }) => {
  if (!notification) return null;

  const icons = {
    success: '\u2713',
    error: '\u2715',
    warning: '\u26A0',
    info: '\u2139'
  };

  return (
    <div className={`notification notification-${notification.type}`}>
      <div className="notification-header">
        <span className="notification-icon">
          {icons[notification.type]}
        </span>
        <strong>{notification.title}</strong>
        <button
          className="notification-close"
          onClick={onClose}
        >
          \u2715
        </button>
      </div>
      {notification.message && (
        <div className="notification-message">{notification.message}</div>
      )}
    </div>
  );
};
